// global types
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_TUTOR_INFO_SUCCESS = 'GET_TUTOR_INFO_SUCCESS';
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
export const UPDATE_USER_INFO_PROFILE_SUCCESS = 'UPDATE_USER_INFO_PROFILE_SUCCESS';
export const NEED_ID_CHECK_SUCCESS = 'NEED_ID_CHECK_SUCCESS';
export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export const UPDATE_IMM_LOADING_STATUS = 'UPDATE_IMM_LOADING_STATUS';
export const REMOVE_USER_INFO = 'REMOVE_USER_INFO';
export const UPDATE_ERROR_MESSAGE = 'UPDATE_ERROR_MESSAGE';
export const UPDATE_AOP_LOADING_STATUS = 'UPDATE_AOP_LOADING_STATUS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_NO_CHANGE_STORE_USER_SUCCESS = 'LOGOUT_NO_CHANGE_STORE_USER_SUCCESS';
export const UPDATE_QUESTION_FONT_SIZE_SUCCESS = 'UPDATE_QUESTION_FONT_SIZE_SUCCESS';
export const UPDATE_HAS_QUESTION_SOUND_MUTED_SUCCESS = 'UPDATE_HAS_QUESTION_SOUND_MUTED_SUCCESS';
export const AFTER_LOGIN_COMPLETE = 'AFTER_LOGIN_COMPLETE';
export const GET_IMPORTANT_MESSAGE_SUCCESS = 'GET_IMPORTANT_MESSAGE_SUCCESS';
export const READ_IMPORTANT_MESSAGE_SUCCESS = 'READ_IMPORTANT_MESSAGE_SUCCESS';
export const GET_GENERATE_BOOK_ALL_FILE_SUCCESS = 'GET_GENERATE_BOOK_ALL_FILE_SUCCESS';
export const SET_IS_DEBUG = 'SET_IS_DEBUG';
export const SET_PZ_TEST = 'SET_PZ_TEST';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const GET_VISITOR_ID_SUCCESS = 'GET_VISITOR_ID_SUCCESS';

export const SET_GOTO_LAST_STUDY = 'SET_GOTO_LAST_STUDY';
export const SET_CURRENT_SERVER_TIME = 'SET_CURRENT_SERVER_TIME';

// global state
export const USER_INFO = 'userInfo';
export const TUTOR_INFO = 'tutorinfo';
export const QUESTION_FONT_SIZE = 'questionFontSize';
export const HAS_QUESTION_SOUND_MUTED = 'hasQuestionSoundMuted';

// im team announcement
export const GET_IM_TEAM_ANNOUNCEMENT_SUCCESS = 'GET_IM_TEAM_ANNOUNCEMENT_SUCCESS';

export const GET_VERSION = 'GET_VERSION';
